import stringify from 'csv-stringify';
import get from 'lodash/get';
import isNil from 'lodash/isNil';
import toPath from 'lodash/toPath';
import moment from 'moment';

import { INTERNAL_DATE_FORMAT } from './constants';

export const getYesNoValue = boolValue => {
  if (isNil(boolValue)) return null;
  return boolValue ? 'Yes' : 'No';
};

// Extend lodash "get" and allow mapping over nested array values, e.g.
// access({ brands: [{ name: 'Zalando' }, …] }, 'brands[*].name')
function access(value, pathSpec) {
  const path = toPath(pathSpec);
  const mapIndex = path.indexOf('*');

  if (mapIndex < 0) return get(value, path);

  const mappable = get(value, path.slice(0, mapIndex));

  if (!Array.isArray(mappable)) return undefined;

  return mappable.map(ea => access(ea, path.slice(mapIndex + 1)));
}

const options = {
  cast: {
    object(value) {
      if (Array.isArray(value)) return value.join(',');
      return JSON.stringify(value);
    },
  },
};

async function serialize(rows) {
  return new Promise((resolve, reject) => {
    stringify(rows, options, (error, csvText) => {
      if (error) {
        reject(error);
      } else {
        resolve(new Blob([csvText], { type: 'text/csv' }));
      }
    });
  });
}

async function createCSV(name, columns, data) {
  const accessors = columns.map(({ accessor }) =>
    typeof accessor === 'function' ? accessor : row => access(row, accessor),
  );

  const headers = columns.map(({ label }) => label);
  const rows = (data || []).map(row => accessors.map(fn => fn(row)));

  const blob = await serialize([headers].concat(rows));

  const datestamp = moment().format(INTERNAL_DATE_FORMAT);
  const length = data ? data.length : 0;

  return { name: `${datestamp} ${length} ${name}.csv`, data: blob };
}

export default createCSV;
